import React from "react";

/**
 * Formateurs null-safe
 */
function money(v) {
  if (v === null || v === undefined) return "—";
  return new Intl.NumberFormat("fr-CA", { style: "currency", currency: "CAD" }).format(v);
}

function number(v, digits = 1) {
  if (v === null || v === undefined) return "—";
  return Number(v).toFixed(digits);
}

/**
 * Tableau de rentabilité par service
 * Colonnes : Service, Visites, Revenu, Coût, Profit, Marge %, Profit/h, Variance %
 */
export default function ServiceBreakdownTable({ rows = [] }) {
  if (!rows || rows.length === 0) {
    return <div className="text-sm text-gray-500 p-4">Aucune donnée par service.</div>;
  }

  return (
    <div className="overflow-x-auto bg-white border rounded-xl">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50 text-gray-600">
          <tr>
            <th className="text-left p-3 font-semibold">Service</th>
            <th className="text-right p-3 font-semibold">Visites</th>
            <th className="text-right p-3 font-semibold">Revenu</th>
            <th className="text-right p-3 font-semibold">Coût total</th>
            <th className="text-right p-3 font-semibold">Profit</th>
            <th className="text-right p-3 font-semibold">Marge %</th>
            <th className="text-right p-3 font-semibold">Profit/h</th>
            <th className="text-right p-3 font-semibold">Variance %</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={`${row.service_type}-${idx}`} className="border-t hover:bg-gray-50">
              <td className="p-3 font-medium">{row.service_type}</td>
              <td className="p-3 text-right">{row.visits_completed}</td>
              <td className="p-3 text-right">{money(row.revenue_total)}</td>
              <td className="p-3 text-right">{money(row.total_cost)}</td>
              <td className={`p-3 text-right font-semibold ${
                row.gross_profit >= 0 ? "text-green-600" : "text-red-600"
              }`}>
                {money(row.gross_profit)}
              </td>
              <td className="p-3 text-right">{number(row.margin_percent, 1)}</td>
              <td className="p-3 text-right">{money(row.profit_per_hour)}</td>
              <td className={`p-3 text-right ${
                row.time_variance_percent > 0 ? "text-orange-600" : "text-green-600"
              }`}>
                {number(row.time_variance_percent, 1)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
